/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconBulletLevel216 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBulletLevel216(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 9.333a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667Zm0 1.333a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconBulletLevel220 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBulletLevel220(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 11.667a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333Zm0 1.667a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconBulletLevel224 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBulletLevel224(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconBulletLevel2 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBulletLevel2(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconBulletLevel216 {...iconProps} />;
        case '20':
            return <IconBulletLevel220 {...iconProps} />;
        case '24':
            return <IconBulletLevel224 {...iconProps} />;
        default:
            return <IconBulletLevel224 {...iconProps} />;
    }
});
